/**
 * Format a value as pretty-printed JSON string.
 * Handles strings (tries to parse as JSON first), objects, nulls, and circular references.
 */
export function formatJson(obj: any): string {
  if (obj == null) return 'No data available';
  if (typeof obj === 'string') {
    try {
      return JSON.stringify(JSON.parse(obj), null, 2);
    } catch {
      return obj;
    }
  }
  try {
    return JSON.stringify(obj, null, 2);
  } catch {
    // Handle circular references
    const seen = new WeakSet();
    return JSON.stringify(obj, (_key, value) => {
      if (typeof value === 'object' && value !== null) {
        if (seen.has(value)) return '[Circular]';
        seen.add(value);
      }
      return value;
    }, 2);
  }
}
